module.exports = __webpack_public_path__ + "static/determined-expanded-3-7c5164eadc1a4d7aa47811e8989a3dc2.png";